( function($, waTheme) {

    var LazyLoading = ( function($) {

        LazyLoading = function(options) {
            var that = this;

            // VARS
            that.list_name = options["names"]["list"];
            that.items_name = options["names"]["items"];
            that.pagind_name = options["names"]["paging"];
            that.load_class = "is-loading";

            // DOM
            that.$wrapper = ( options["$wrapper"] || false );
            that.$list = that.$wrapper.find(that.list_name);
            that.$window = $(window);

            // DYNAMIC VARS
            that.$paging = that.$wrapper.find(that.pagind_name);
            that.scrollWatcher = null;
            that.onScrollLoading = false;

            // INIT
            that.init();
        };

        LazyLoading.prototype.init = function() {
            var that = this;

            if (that.onScrollLoading) {
                that.addWatcher();
            }

            that.bindEvents();
        };

        LazyLoading.prototype.bindEvents = function() {
            var that = this;

            $(document).on("click", ".js-products-paging-load", function () {
                event.preventDefault();
                that.loadNextPage();
            });
        };

        LazyLoading.prototype.addWatcher = function() {
            var that = this;

            that.$window.on("scroll", scrollWatcher);
            function scrollWatcher() {
                var is_exist = $.contains(document, that.$wrapper[0]);
                if (is_exist) {
                    that.onScroll();
                } else {
                    that.$window.off("scroll", scrollWatcher);
                }
            }

            that.scrollWatcher = scrollWatcher;
        };

        LazyLoading.prototype.stopWatcher = function() {
            var that = this;

            if (that.scrollWatcher) {
                var scrollWatcher = that.scrollWatcher;
                that.$window.off("scroll", scrollWatcher);
            }
        };

        LazyLoading.prototype.onScroll = function() {
            var that = this,
                is_paging_exist = ( $.contains(document, that.$paging[0]) );

            if (is_paging_exist) {

                var $window = that.$window,
                    scroll_top = $window.scrollTop(),
                    display_height = $window.height(),
                    paging_top = that.$paging.offset().top;

                // If we see paging, stop watcher and run load
                if (scroll_top + display_height >= paging_top) {
                    that.stopWatcher();
                    that.loadNextPage();
                }

            } else {
                that.stopWatcher();
            }

        };

        LazyLoading.prototype.loadNextPage = function() {
            var that = this,
                next_page_url = getNextUrl(),
                $paging = that.$paging;

            function getNextUrl() {
                var $nextPage = that.$paging.find(".selected").next(),
                    result = false;

                if ($nextPage.length) {
                    result = $nextPage.find("a").attr("href");
                }

                return result;
            }

            function showLoad() {
                $paging.addClass(that.load_class);
                if (that.onScrollLoading) {
                    var $loading = `<div class="b-products-spinner position-absolute start-50 translate-middle">
                                    <div class="spinner-border text-gray-500" role="status">
                                        <span class="visually-hidden">Loading...</span>
                                    </div>
                                </div>`;

                    $paging.append($loading);
                } else {
                    let $loader  = $(".js-products-paging-load");
                    let loadingText = $loader.data("loading-text");

                    $loader.find(".spinner-border").removeClass("d-none");
                    $loader.find(".spinner-text").html(loadingText);
                }
            }

            if (next_page_url) {

                showLoad();

                $.get(next_page_url, function(response) {
                    var $category = $(response),
                        $newItems = $category.find(that.list_name + " " + that.items_name),
                        $newPaging = $category.find(that.pagind_name);

                    that.$list.append($newItems);

                    $paging.after($newPaging);

                    $paging.remove();

                    that.$paging = $newPaging;

                    // Инициализируем заново товары
                    // new window.waTheme.init.shop.ProductsInit();

                    // Обновляем инстанс ленивой загрузки картинок
                    waTheme.init.site.ImageLazyLoad.update();

                    if (that.onScrollLoading) {
                        that.addWatcher();
                    }
                });
            }
        };

        return LazyLoading;

    })($);

    var ProductsInit = (function ($) {

        ProductsInit = function () {
            var that = this;

            // DOM
            that.$wrapper = $(".s-products-wrapper");

            // CONST

            // DYNAMIC VARS

            // INIT
            that.init();

            // EVENTS
        };

        ProductsInit.prototype.init = function () {
            var that = this;

            if (that.$wrapper.length) {
                that.$wrapper.each(function () {
                    new window.waTheme.init.shop.Products({
                        $wrapper: $(this),
                        use_lazy: !!$(this).find(".s-paging-wrapper").hasClass("is-lazy-loading"),
                    });

                    let $quantity = $(this).find(".s-quantity-section");
                    if ($quantity) {
                        $quantity.each(function () {
                            let product_id = $(this).parents(".s-product-wrapper").data("product-id");
                            new waTheme.init.shop.Quantity({
                                $wrapper: $(this),
                                denominator: window.waTheme["products"][`${product_id}`].denominator,
                                step: window.waTheme["products"][`${product_id}`].step,
                                min: window.waTheme["products"][`${product_id}`].min,
                                max: window.waTheme["products"][`${product_id}`].max,
                                locales: window.waTheme["products"][`${product_id}`].locales,
                                currency: window.waTheme["products"][`${product_id}`].currency,
                            });
                        });
                    }
                });
            }

        };

        return ProductsInit;

    })($);

    var Products = ( function($) {

        Products = function(options = {}) {
            var that = this;

            // DOM
            that.$wrapper = options["$wrapper"];
            that.$products = that.$wrapper.find(".s-product-wrapper:not(.s-product-wrapper-loaded)");

            // VARS
            that.use_lazy = ( options["use_lazy"] || false );
            that.use_slider = ( options['use_slider'] || false );

            console.log(that.use_lazy);

            // DYNAMIC VARS
            that.activeClass = "active";

            // INIT
            that.init();
        };

        Products.prototype.init = function() {
            var that = this;

            that.$products.addClass("s-product-wrapper-loaded");

            //
            //
            if (that.use_lazy) {
                that.initLazy();
            }
            //
            that.bindEvents();

        };

        Products.prototype.bindEvents = function() {
            var that = this,
                $wrapper = that.$wrapper;

            $wrapper.on("submit", "form.add-to-cart", function(event) {
                event.preventDefault();
                that.onSubmitProduct($(this));
            });

            $wrapper.on("click", ".js-preview-button", function (event) {
                event.preventDefault();
                that.onSubmitProduct($(this).parents(".s-product-wrapper").find("form.add-to-cart"), $(this).data("url"));
            });

            // Change image on hover
            $wrapper.on("mouseenter", ".b-products-images__nav", function () {

                //
                var $wrapper = $(this).parents(".b-products-images");

                //
                var step = parseInt($(this).data("step"));
                var currentStep = parseInt($wrapper.find(".b-products-images__nav.active").data("step"));

                if (step !== currentStep) {
                    that.changeImage($wrapper, step)
                }
            });

            $wrapper.on("mouseleave", ".b-products-images__nav", function () {
                if ($(this).data("return") === true) {
                    var $wrapper = $(this).parents(".b-products-images");
                    that.changeImage($wrapper, 1);
                }
            });
        };

        //

        Products.prototype.initLazy = function() {
            var that = this;

            new LazyLoading({
                $wrapper: that.$wrapper,
                names: {
                    list: ".s-products-list",
                    items: ".s-product-wrapper",
                    paging: ".s-paging-wrapper"
                }
            });

            console.log("initLazy");
        };

        // ADD PRODUCT

        Products.prototype.onSubmitProduct = function($form, href) {
            var that = this,
                $product = $form.closest(".s-product-wrapper"),
                $button = $form.find(".js-add-button"),
                $preview_button = $product.find(".js-preview-button"),
                product_name = $product.find(".s-product-header").text(),
                product_image = $product.find(".b-products-images__items .b-products-images__image:first-child").html(),
                product_href = href ? href : $form.data("url"),
                add_class = "btn-theme",
                added_class = "btn-outline-theme",
                timer = 0,
                time = 300;

            let toastHTML =
                `<div class="b-products-toast d-flex align-items-center">
                    <div class="b-products-toast__image">
                       ${product_image}
                    </div>
                    <div class="ms-3">
                        <div class="fs-md fw-bold mb-1">
                            ${window.waTheme.locale.product_added_to_cart}
                        </div>
                        <div class="fs-sm">
                            ${product_name}
                        </div>
                    </div>
                </div>`;

            $button.attr("disabled", true);
            $preview_button.attr("disabled", true);
            // $button.find(".spinner-border").addClass("d-none");

            if (product_href) {

                $.post(product_href, function( html ) {

                    $button.attr("disabled", false);
                    $preview_button.attr("disabled", false);
                    // $button.find(".spinner-border").removeClass("d-none");

                    var dialog = new window.waTheme.init.site.Dialog({
                        html: html
                    });

                    var $dialog = dialog.$dialog;

                    $dialog.on("addedToCart", function() {

                        $button
                            .attr("disabled", true)
                            .removeClass(add_class)
                            .addClass(added_class);
                        $button.find(".spinner-text").html(window.waTheme.locale["added_to_cart"]);

                        clearTimeout(timer);
                        timer = setTimeout( function() {
                            var is_exist = $.contains(document, $button[0]);
                            if (is_exist) {

                                $dialog.modal("hide");
                                $button.attr("disabled", false);

                                const toast = new window.waTheme.init.site.Toast({
                                    html: toastHTML
                                });
                            }
                        }, time);
                    });
                });

            } else {

                $.post($form.attr('action') + '?items=1&html=1', $form.serialize(), function(response) {
                    if (response.status === "ok") {

                        if (!waTheme.apps["shop"].cart) {
                            location.reload();
                            return false;
                        }

                        //
                        $button
                            .removeClass(add_class)
                            .addClass(added_class);
                        $button.find(".spinner-text").html(window.waTheme.locale["added_to_cart"]);

                        // Update Cart at Header
                        if (response["data"]) {
                            var count = response["data"]["count"],
                                text = response["data"]["total"];

                            if (text && count >= 0) {
                                waTheme.apps["shop"].cart.update(response["data"]);
                            }
                        }

                        clearTimeout(timer);
                        timer = setTimeout( function() {
                            var is_exist = $.contains(document, $button[0]);
                            if (is_exist) {
                                $button.attr("disabled", false);
                                $preview_button.attr("disabled", false);
                                const toast = new window.waTheme.init.site.Toast({
                                    html: toastHTML
                                });
                            }
                        }, time);

                    } else if (response.status === "fail") {

                        let toastHTML =
                            `<div class="b-products-toast d-flex align-items-center">
                                ${response.errors}
                            </div>`;

                        const toast = new window.waTheme.init.site.Toast({
                            html: toastHTML
                        });

                    }

                }, "json").always( function() {
                    // $button.find(".spinner-border").addClass("d-none");
                    $preview_button.attr("disabled", false);
                });
            }
        };

        Products.prototype.changeImage = function ($wrapper, step) {
            var that = this;

            var $images = $wrapper.find(".b-products-images__image");
            var $navs = $wrapper.find(".b-products-images__nav");
            var $dots = $wrapper.find(".b-products-images__dot");

            //
            $images.removeClass(that.activeClass);
            $navs.removeClass(that.activeClass);
            $dots.removeClass(that.activeClass);

            //
            $wrapper.find(`.b-products-images__image[data-step="${step}"]`).addClass(that.activeClass);
            $wrapper.find(`.b-products-images__nav[data-step="${step}"]`).addClass(that.activeClass);
            $wrapper.find(`.b-products-images__dot[data-step="${step}"]`).addClass(that.activeClass);

        };

        return Products;

    })($);

    waTheme.init.shop.ProductsInit = ProductsInit;
    waTheme.init.shop.Products = Products;

    //
    new window.waTheme.init.shop.ProductsInit();

})(jQuery, window.waTheme);